export default __webpack_public_path__ + "static/media/sistemas-gestao.93fceeae.svg";